import { render, staticRenderFns } from "./structure-layout.vue?vue&type=template&id=74789fb2&scoped=true&"
import script from "./structure-layout.vue?vue&type=script&lang=js&"
export * from "./structure-layout.vue?vue&type=script&lang=js&"
import style0 from "./structure-layout.vue?vue&type=style&index=0&id=74789fb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74789fb2",
  null
  
)

export default component.exports